export default __webpack_public_path__ + "static/media/tab_qna_inactive.dafdf059.svg";